import { render, staticRenderFns } from "./ContactsTable.vue?vue&type=template&id=6340ee0a"
import script from "./ContactsTable.vue?vue&type=script&lang=js"
export * from "./ContactsTable.vue?vue&type=script&lang=js"
import style0 from "./ContactsTable.vue?vue&type=style&index=0&id=6340ee0a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports